var _circle, _circle2, _path, _circle3, _circle4, _path2, _path3, _path4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalmMindset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 130,
    r: 75,
    stroke: "#38bdf8",
    strokeWidth: 2,
    strokeOpacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 130,
    r: 55,
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 140,
    r: 4,
    fill: "#fafcfb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 140,
    r: 4,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 158 Q200 166 208 158",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80 L100 110 M340 80 L300 110 M55 180 L100 160 M345 180 L300 160",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.35,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 40 L200 65 M120 130 L145 130 M280 130 L255 130",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.25,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 130,
    r: 30,
    stroke: "#38bdf8",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalmMindset);
export default __webpack_public_path__ + "static/media/calm-mindset.1dacf0a4f35b7361ab9f1edf5487dfae.svg";
export { ForwardRef as ReactComponent };